<div class="sk-container" [ngClass]="{ 'sk-loading': !couponSegments }">
    <loading-screen [displayed]="!couponSegments" [templateType]="'GENERIC'"></loading-screen>
    <div
        [ngClass]="isSportTab ? 'coupon-container' : 'heuristic-container'"
        [style.--header-items-count]="couponSegmentsWithCoupons().length"
        [style.--list-card-count]="couponSegmentsCount()">
        <ng-container *rxFor="let couponSegment of couponSegmentsWithCoupons(); trackBy: trackById">
            <header
                class="split-header-coupons"
                [ngClass]="{ 'split-header-coupons-coral': isCoral }"
                [textContent]="couponSegment.title"
                data-crlat="couponSegmentTitle"></header>
            <div [ngClass]="{ 'list-container': !isSportTab }" data-crlat="couponContainer" [style.--list-card-count]="couponSegment.coupons.length">
                <list-card
                    *rxFor="let coupon of couponSegment.coupons; trackBy: trackById"
                    [item]="coupon"
                    (click)="onClick(coupon)"
                    [link]="couponUrl(coupon)"
                    appDomainSuffixHref
                    data-crlat="couponItem"
                    [ngClass]="!isCoral ? 'list-card-ld' : 'list-card-crl'">
                    @if (coupon.enableCouponNewBadge) {
                        <svg class="list-new-icon" data-crlat="listnewIcon">
                            <use xlink:href="#special-list-icon"></use>
                        </svg>
                    }
                </list-card>
            </div>
        </ng-container>
    </div>
</div>
